export interface FileUploadConfiguration {
  maxFileSizeInMB: number;
  supportedFileTypes: string[];
  supportedFileExtensions: string[];
}

export const ckEditorSupportedDocumentConfiguration: FileUploadConfiguration = {
  maxFileSizeInMB: 10,
  supportedFileTypes: [
    'image/jpg',
    'image/jpeg',
    'image/png'
  ],
  supportedFileExtensions: [
    '.jpg',
    '.jpeg',
    '.png'
  ]
}

export const supportingDocumentConfiguration: FileUploadConfiguration = {
  maxFileSizeInMB: 10,
  supportedFileTypes: [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'image/jpeg',
    'image/png'
  ],
  supportedFileExtensions: [
    '.pdf',
    '.doc',
    '.docx',
    '.ppt',
    '.pptx',
    '.xls',
    '.xlsx',
    '.jpg',
    '.jpeg',
    '.png'
  ]
};

export const userResourceDocumentConfiguration: FileUploadConfiguration = {
  maxFileSizeInMB: 45,
  supportedFileTypes: [
    'application/pdf',
    'application/msword',
    'application/vnd.ms-outlook',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'image/jpeg',
    'image/png',
    'image/gif',
    'video/quicktime'
  ],
  supportedFileExtensions: [
    '.pdf',
    '.doc',
    '.docx',
    '.oft',
    '.msg',
    '.ppt',
    '.pptx',
    '.xls',
    '.xlsx',
    '.jpeg',
    '.jpg',
    '.png',
    '.gif',
    '.mov'
  ]
};

export const executiveSummaryDocumentConfiguration: FileUploadConfiguration = {
  maxFileSizeInMB: 20,
  supportedFileTypes: [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'image/jpeg',
    'image/png'
  ],
  supportedFileExtensions: [
    '.pdf',
    '.doc',
    '.docx',
    '.ppt',
    '.pptx',
    '.xls',
    '.xlsx',
    '.jpeg',
    '.jpg',
    '.png'
  ]
};

export const awardExecutiveSummaryFileTemplateConfiguration: FileUploadConfiguration = {
  maxFileSizeInMB: 20,
  supportedFileTypes: [
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ],
  supportedFileExtensions: [
    '.doc',
    '.docx',
    '.ppt',
    '.pptx',
    '.xls',
    '.xlsx'
  ]
};

export const MAX_UPLOADED_MEDIA_COUNT = 11;

export const questionnaireImageFileConfiguration: FileUploadConfiguration = {
  maxFileSizeInMB: 5,
  supportedFileTypes: [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/gif',
    'image/tiff',
    'application/postscript',
    'image/svg+xml',
  ],
  supportedFileExtensions: [
    '.jpg',
    '.png',
    '.gif',
    '.tif',
    '.eps',
    '.svg',
  ],
};

export const questionnaireVideoFileConfiguration: FileUploadConfiguration = {
  maxFileSizeInMB: 20,
  supportedFileTypes: [
    'video/mp4',
    'video/x-ms-wmv',
    'video/x-ms-asf',
  ],
  supportedFileExtensions: [
    '.mp4',
    '.wmv',
    '.asf',
    '.asx',
  ],
};

export const questionnaireLogoFileConfiguration: FileUploadConfiguration = {
  maxFileSizeInMB: 10,
  supportedFileTypes: [
    'image/png',
  ],
  supportedFileExtensions: [
    '.png',
  ]
}

export const emailTemplateBannerImageFileConfiguration: FileUploadConfiguration = {
  maxFileSizeInMB: 5,
  supportedFileTypes: [
    'image/jpeg',
    'image/png',
    'image/jpg',
  ],
  supportedFileExtensions: [
    '.jpg',
    '.png',
    '.jpeg',
  ],
};

export const emailTemplateAttachmentConfiguration: FileUploadConfiguration = {
  maxFileSizeInMB: 20,
  supportedFileTypes: [
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/msword',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  ],
  supportedFileExtensions: [
    '.pdf',
    '.docx',
    '.doc',
    '.ppt',
    '.pptx',
  ],
};
